import { ghostButton, primaryButton } from '../components/ui';
import { getTopic } from '../content/topics';
import { BADGE_BY_ID } from '../engine/progress';
import { useApp, useStartSet } from '../store/useApp';

export function Done() {
  const { state, dispatch } = useApp();
  const startSet = useStartSet();
  const result = state.result;
  if (!result) return null;

  const topic = getTopic(result.topicId);
  const clean = result.right === result.total && result.parked === 0;
  const newBadge = result.newBadgeId ? BADGE_BY_ID.get(result.newBadgeId) : null;

  const title = clean ? 'Clean run.' : result.right > 0 ? 'Set done.' : 'You showed up.';
  const line = result.parked
    ? 'The parked ones come back another day. Nothing lost.'
    : 'That is the whole ask for today. Anything more is extra.';

  return (
    <div
      style={{
        padding: '30px 22px',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <div
        className="num"
        style={{
          width: 82,
          height: 82,
          borderRadius: 999,
          background: 'oklch(0.82 0.17 130 / .14)',
          border: '2px solid var(--lime-line)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          font: '800 27px/1 var(--font-display)',
          color: 'var(--lime-bright)',
        }}
      >
        {result.right}/{result.total}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
        <div style={{ font: '700 26px/1.15 var(--font-display)', letterSpacing: '-.02em' }}>
          {title}
        </div>
        <div
          style={{ font: '400 14.5px/1.5 var(--font-body)', color: 'var(--text-3)', textWrap: 'pretty' }}
        >
          {line}
        </div>
      </div>

      {newBadge && (
        <div
          role="status"
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 13,
            padding: '15px 16px',
            borderRadius: 16,
            background: 'oklch(0.82 0.17 65 / .1)',
            border: '1px solid var(--amber-line)',
            textAlign: 'left',
          }}
        >
          <div
            className="num"
            style={{
              flex: 'none',
              width: 42,
              height: 42,
              borderRadius: 12,
              background: 'oklch(0.82 0.17 65 / .18)',
              border: '1px solid var(--amber-line)',
              color: 'var(--amber)',
              font: '700 15px/1 var(--font-display)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {newBadge.chip}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <div
              style={{
                font: '600 10.5px/1 var(--font-body)',
                letterSpacing: '.13em',
                textTransform: 'uppercase',
                color: 'var(--amber)',
              }}
            >
              Badge earned
            </div>
            <div style={{ font: '700 16px/1.2 var(--font-display)' }}>{newBadge.name}</div>
            <div style={{ font: '400 12px/1.35 var(--font-body)', color: 'var(--text-4)' }}>
              Yours for good. It does not reset.
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: 10, width: '100%' }}>
        {/* "Worked", not "solved". This counter includes questions she got
            wrong, and a 0/4 run that reports four problems solved is a lie
            she will notice. */}
        <Stat value={state.progress.solved} label="problems worked" tone="var(--lime)" />
        <Stat value={result.parked} label="parked" tone="var(--amber)" />
      </div>

      <div
        style={{
          width: '100%',
          padding: '13px 15px',
          borderRadius: 13,
          background: 'var(--surface)',
          border: '1px dashed rgba(255,255,255,.14)',
          font: '400 13px/1.5 var(--font-body)',
          color: 'var(--text-3)',
          textAlign: 'left',
          textWrap: 'pretty',
        }}
      >
        Stand up and move for a minute before anything else. It genuinely helps the next set stick.
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}>
        <button
          type="button"
          style={primaryButton}
          onClick={() => startSet(topic.id)}
        >
          One more set
        </button>
        <button
          type="button"
          style={{ ...ghostButton, width: '100%', flex: 'none' }}
          onClick={() => dispatch({ type: 'exit' })}
        >
          Done for now
        </button>
      </div>
    </div>
  );
}

function Stat({ value, label, tone }: { value: number; label: string; tone: string }) {
  return (
    <div
      style={{
        flex: 1,
        padding: 14,
        borderRadius: 13,
        background: 'var(--surface)',
        border: '1px solid var(--line)',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <div className="num" style={{ font: '700 21px/1 var(--font-display)', color: tone }}>
        {value}
      </div>
      <div style={{ font: '500 11.5px/1 var(--font-body)', color: 'var(--text-4)' }}>{label}</div>
    </div>
  );
}
